module.exports = __webpack_public_path__ + "static/logo-qf-8c1e0449d887db8064635baa47843bfe.svg";